import React from 'react'
import TitleLockup, { TitleLockupProps } from 'src/modules/molecules/title-lockup'
import * as styles from './TextWrap.module.scss'

interface TextWrapProps extends TitleLockupProps {
  paragraphs: string[]
}

const TextWrap: React.FC<TextWrapProps> = ({ paragraphs, ...titleLockupProps }) => {
  return (
    <div className={styles.container}>
      <TitleLockup {...titleLockupProps} />
      <hr />
      <div className={styles.containerContent}>
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </div>
  )
}

export default TextWrap
